<script lang='ts'>
    import { formatXSSDetails, round, type XSSDetails } from "../../Util/utils";
    import ProgramAchievabilityStatusIcon from "./ProgramAchievabilityStatusIcon.svelte";
    import ProgramTargetChangeValue from "./ProgramTargetChangeValue.svelte";
    import type { TargetAchievability } from "../modules/ProgramAchievability"
    import { Skeleton } from "@/Common";

    export let currentTL: XSSDetails
    export let targetTL: XSSDetails
    export let targetAchievability: TargetAchievability
    export let description: string = ""
    export let estimatedRowName = "Estimated"
    export let disabled = false

    let formCurrentTL: XSSDetails<string>
    let formTargetTL: XSSDetails<string>
    $: if (currentTL && targetTL) {
        formCurrentTL = formatXSSDetails(currentTL)
        formTargetTL = formatXSSDetails(targetTL)
    }
</script>

<div class="flex flex-col gap-6 text-left">
    <div class="col-span-5 text-base font-bold text-left flex flex-col">
        <span class="leading-none">Training Load</span>
        <span class="text-slate-600 font-normal text-sm">{description}</span>
    </div>
    {#if currentTL && targetTL && !disabled}
    <div class="grid items-baseline gap-2 md:gap-3">
        <span class="col-start-2 row-start-1 text-sm text-slate-500">Total</span>
        <span class="col-start-3 text-sm text-slate-500">Low</span>
        <span class="col-start-4 text-sm text-slate-500">High</span>
        <span class="col-start-5 text-sm text-slate-500">Peak</span>
        <span class="row-start-2 text-sm text-left text-slate-600">Current</span>
        <span class="">{formCurrentTL.xss}</span>
        <span class="text-[--color-xlss]">{formCurrentTL.xlss}</span>
        <span class="text-[--color-xhss]">{formCurrentTL.xhss}</span>
        <span class="text-[--color-xpss]">{formCurrentTL.xpss}</span>
        <span class="row-start-3 text-sm text-left text-slate-600">{estimatedRowName}</span>
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="">{formTargetTL.xss}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={Math.round(targetTL.xss) - Math.round(currentTL.xss)} />
            </div>
        </span>
        
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="text-[--color-xlss]">{formTargetTL.xlss}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={Math.round(targetTL.xlss) - Math.round(currentTL.xlss)} />
                <ProgramAchievabilityStatusIcon status={targetAchievability.low}/>
            </div>
        </span>
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="text-[--color-xhss]">{formTargetTL.xhss}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={round(targetTL.xhss, 1) - round(currentTL.xhss, 1)} />
                <ProgramAchievabilityStatusIcon status={targetAchievability.high}/>
            </div>
        </span>
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="text-[--color-xpss]">{formTargetTL.xpss}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={round(targetTL.xpss, 1) - round(currentTL.xpss, 1)} />
                <ProgramAchievabilityStatusIcon status={targetAchievability.peak}/>
            </div>
        </span>
    </div>
    {:else}
    <div class="flex flex-col gap-3">
        <Skeleton class="ml-auto w-9/12 h-6"/>
        <Skeleton class= "h-20"/>
    </div>
    {/if}
</div>